var _style, _g, _g2, _g3, _g4, _g5, _g6, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArturHead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 387.4 538.3",
    style: {
      enableBackground: "new 0 0 387.4 538.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F6BA19;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#100F0D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M304,151.2V59.6l-52.9,53c-3.8,3.9-9.1,5.8-14.5,5c-5.3-0.7-10.1-3.9-12.8-8.5l-32.6-56.7l-32.6,56.7 c-2.7,4.6-7.5,7.8-12.8,8.5c-5.5,0.7-10.8-1.1-14.5-5l-52.9-53v91.6H304"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M269.4,344.8c-20.5,20.6-47.9,31.9-76.9,31.9c-29.1,0-56.4-11.3-76.9-31.9c-6.9-6.8-6.9-17.8,0-24.6 c6.8-6.8,17.8-6.8,24.6,0c28,28,76.6,28,104.6,0c6.8-6.8,17.8-6.8,24.7,0C276.2,326.9,276.2,338,269.4,344.8"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M74.4,256.7c0-9.5,7.7-17.2,17.2-17.2h54.7c8.3,0,16,5.6,17.6,13.8c2.1,10.9-6.3,20.6-16.8,20.6H91.5 C82.1,273.8,74.3,266.1,74.4,256.7"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.3,185.5v235.4l252.5-0.2c4.6,0,9.1,1.8,12.3,5.1l53.9,53.9V185.5H34.3"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M131.3,112.7c3.8,3.8,9.1,5.7,14.5,5c5.3-0.7,10.1-3.9,12.8-8.5l32.6-56.7l32.6,56.7c2.7,4.6,7.5,7.8,12.8,8.5 c5.4,0.8,10.8-1.1,14.5-5l52.9-53v91.6H78.5V59.6L131.3,112.7z M353,480L299.1,426c-3.2-3.3-7.7-5.1-12.3-5.1l-252.5,0.2V185.5 h318.7L353,480z M338.4,150.9V17.5c2.1-7.1-2.2-13.4-8.6-16.1c-6.5-2.7-14-1.2-19,3.8L244,71.9L207.7,8.7c-6.2-10.7-24-10.7-30.2,0 L141,71.9L74.3,5.1c-5-5-12.4-6.5-19-3.8c-6.4,2.7-10.7,9-11.2,16v133.9H17.3C7.7,151.2,0,159,0,168.5V438c0,4.6,1.8,9,5.1,12.2 c3.3,3.3,7.7,5.1,12.2,5.1l262.3-0.2l78.3,78.2c3.3,3.3,7.7,5,12.2,5c2.2,0,4.5-0.4,6.6-1.3c6.4-2.7,10.7-9,10.7-16V168.4 c0-9.6-7.8-17.4-17.4-17.4L338.4,150.9z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M164.1,256.7c0-9.5-7.7-17.2-17.2-17.2H92.3c-8.3,0-16,5.6-17.6,13.8c-2.1,10.9,6.3,20.6,16.8,20.6H147 C156.5,273.8,164.2,266.1,164.1,256.7"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M294.2,278.1c-3.5,0-7.1-1.1-10.2-3.3c-7-5.2-15.1-7.9-23.3-7.9c-7.4,0-14.4,2.1-21,6.3c-8,5.1-18.6,2.8-23.7-5.2 c-5.1-8-2.8-18.6,5.2-23.7c12-7.7,25.6-11.8,39.5-11.8c15.6,0,30.7,5.1,43.7,14.6c7.6,5.6,9.3,16.4,3.6,24 C304.7,275.7,299.5,278.1,294.2,278.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M269.4,344.8c-20.5,20.6-47.9,31.9-76.9,31.9c-29.1,0-56.4-11.3-76.9-31.9c-6.9-6.8-6.9-17.8,0-24.6 c6.8-6.8,17.8-6.8,24.6,0c28,28,76.6,28,104.6,0c6.8-6.8,17.8-6.8,24.7,0C276.2,326.9,276.2,338,269.4,344.8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArturHead);
export default __webpack_public_path__ + "static/media/artur_head.a1d37c03c4b2c542187973de361f3bec.svg";
export { ForwardRef as ReactComponent };